import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import AdminPage from "../../components/AdminPage";
import TableComponent from "../../components/adminTableComponent";
import DeleteModalContent from "../../components/DeleteModalContent/DeleteModalContent";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { SpecificView } from "../../components/SpecificView/SpecificView";
import { AddIndustryType } from "./AddIndustryType";
import { loadIndustriesTypes } from "./loadData";
import { IndustryTypeHeaders } from "./tableHeaders";

const IndustryTypes = ({}) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [industryTypes, setIndustryTypes] = useState([]);
  const [opened, setOpened] = useState(false);
  const [update, setUpdate] = useState(false);
  const [viewModalState, setViewModalState] = useState(false);
  const [viewModalData, setViewModalData] = useState({});
  const [editData, setEditData] = useState({});
  const [deleteData, setDeleteData] = useState({});
  const [deleteModalState, setDeleteModalState] = useState(false);
  const [editModalState, setEditModalState] = useState(false);

  useEffect(() => {
    loadIndustriesTypes(setLoading).then(setIndustryTypes);
  }, [location.pathname, update]);

  return (
    <AdminPage title="Industry Types">
      <ModalWrapper
        opened={viewModalState}
        setOpened={setViewModalState}
        title={"Industry Type Details"}
        InternalComponent={
          <SpecificView
            name={viewModalData.typeName}
            description={viewModalData.typeDescription}
            date={viewModalData?.createdDate}
            status={viewModalData?.state}
          />
        }
      />
      <ModalWrapper
        opened={deleteModalState}
        setOpened={setDeleteModalState}
        title={"Delete Industry Type"}
        InternalComponent={
          <DeleteModalContent
            route={`industryType/deleteIndustryType/${deleteData?._id}`}
            type={"Industry Type"}
            setUpdate={setUpdate}
            setOpened={setDeleteModalState}
            setLoading={setLoading}
          />
        }
      />
      <AddIndustryType
        opened={opened}
        setOpened={setOpened}
        setUpdate={setUpdate}
        editData={editData}
        setEditData={setEditData}
        setEditModalState={setEditModalState}
        editModalState={editModalState}
        setLoading={setLoading}
      />
      <LoaderWrapper loading={loading}>
        <TableComponent
          headCells={IndustryTypeHeaders}
          rowData={industryTypes}
          opened={opened}
          setOpened={setOpened}
          showAddButton={true}
          setViewModalData={setViewModalData}
          setViewModalState={setViewModalState}
          setEditData={setEditData}
          setEditModalState={setEditModalState}
          setDeleteData={setDeleteData}
          setDeleteModalState={setDeleteModalState}
        />
      </LoaderWrapper>
    </AdminPage>
  );
};

export default withTranslation()(IndustryTypes);
